import { defineMessages } from 'react-intl-next';

const messages: {
	clearAllButton: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	selectAllButtonLabel: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	selectedItemsLabel: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	selectFirstButtonLabel: {
		defaultMessage: string;
		description: string;
		id: string;
	};
} = defineMessages({
	selectedItemsLabel: {
		defaultMessage:
			'{numberSelected} {numberOfSelectedItems, plural, one {selected} other {selected}}',
		id: 'floating-toolbar.selected-items-label',
		description: 'The label for how many items are selected',
	},
	clearAllButton: {
		defaultMessage: 'Clear all',
		id: 'floating-toolbar.clear-all-button',
		description:
			'The label for the floating toolbar X button that clear the selection and close the toolbar',
	},
	selectAllButtonLabel: {
		defaultMessage: 'Select all',
		id: 'floating-toolbar.select-all-button-label',
		description: 'The label for the floating toolbar select all button',
	},
	selectFirstButtonLabel: {
		defaultMessage: 'Select first {numberOfIssues}',
		id: 'floating-toolbar.select-first-button-label',
		description: 'The label for the floating toolbar select first given number of issues button',
	},
});
export default messages;
